<template>
    <el-card class="operation-container noBorder">
        <Transition name="fade">
            <el-form
                v-if="formVisible"
                :inline="true"
                class="search-form"
                :model="search_data"
                style="padding: 0"
                label-position="top"
            >
                <el-form-item label="应用名称">
                    <el-input v-model="search_data.name" clearable placeholder="请输入" />
                </el-form-item>
                <el-form-item label="应用状态">
                    <el-select v-model="search_data.status" clearable placeholder="请选择">
                        <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                </el-form-item>
                <el-form-item style="margin-left: auto; padding-top: 10px">
                    <el-button type="primary" :icon="Search" @click="getAppData">搜索</el-button>
                    <el-button :icon="Refresh" @click="resetQueryForm">重置</el-button>
                </el-form-item>
            </el-form>
        </Transition>
        <div style="display: flex; margin-bottom: 10px">
            <el-button type="primary" :icon="Plus" v-permission="['application:add']" @click="onAddClick()">添加</el-button>
            <el-button :icon="DCaret" @click="handleSort">一键排序</el-button>
            <div class="card-header" style="margin-left: auto">
                <div class="circle-btn">
                    <el-tooltip class="box-item" effect="dark" :content="formVisible ? '隐藏搜索' : '显示搜索'" placement="top">
                        <el-button plain circle @click="formVisible = !formVisible" :icon="Search" size="small"></el-button>
                    </el-tooltip>
                </div>
            </div>
        </div>
        <el-table :data="table_data" border v-loading="tableLoading" style="width: 100%">
            <el-table-column label="序号" width="60" type="index"></el-table-column>
            <el-table-column prop="app_id" label="AppId"></el-table-column>
            <el-table-column prop="name" label="应用名称"></el-table-column>
            <el-table-column prop="contact" label="联系人" width="100"></el-table-column>
            <el-table-column prop="phone" label="联系电话" width="170"></el-table-column>
            <el-table-column prop="email" label="邮箱" width="200"></el-table-column>
            <el-table-column prop="list_order" label="排序" width="130">
                <template #default="scope">
                    <el-input-number
                        style="width: 100px"
                        type="number"
                        v-model="scope.row.list_order"
                        :min="0"
                        :max="999999"
                        controls-position="right"
                        size="small"
                    />
                </template>
            </el-table-column>
            <el-table-column prop="status" label="状态" width="80">
                <template #default="{ row }">
                    <el-tag v-if="row.status == 1">正常</el-tag>
                    <el-tag v-else type="danger">停用</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="230">
                <template #default="{ row }">
                    <el-button type="primary" link :icon="View" @click="onShowClick(row)">查看</el-button>
                    <el-button type="primary" link :icon="Edit" @click="onEditClick(row)" v-permission="['application:put']">
                        修改
                    </el-button>
                    <el-button
                        type="primary"
                        link
                        :icon="Delete"
                        @click="onRemoveClick(row)"
                        v-permission="['application:remove']"
                    >
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            background
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="search_data.page"
            :page-sizes="[10, 20, 50]"
            :page-size="search_data.page_size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        ></el-pagination>
        <app-forms v-model="formDialogVisible" :isForm="isForm" :roleId="selectId" @updateForm="getAppData"></app-forms>
    </el-card>
</template>

<script setup>
import { onActivated, ref, watch } from 'vue'
import { batchSort, delApp, getAppLists } from '@/api/application.js'
import AppForms from './components/appForms.vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { DCaret, Delete, Edit, Plus, Refresh, Search, View } from '@element-plus/icons'

const tableLoading = ref(true)
const table_data = ref([])
const search_data = ref({
    name: '',
    status: '',
    page: 1,
    page_size: 10
})
// 获取应用管理列表
const getAppData = async () => {
    tableLoading.value = true
    const result = await getAppLists({ ...search_data.value })
    tableLoading.value = false
    table_data.value = result.lists
    total.value = result.total
}
getAppData()

const total = ref(0)
const statusOptions = [
    { label: '正常', value: 1 },
    { label: '停用', value: 0 }
]
// 重置
const resetQueryForm = () => {
    Object.keys(search_data.value).forEach((key) => {
        if (key !== 'page' && key !== 'page_size') search_data.value[key] = ''
    })
    getAppData()
}
const formVisible = ref(true)
getAppData()

const formDialogVisible = ref(false)
const isForm = ref(false) // 是否是表单
const selectId = ref('') // 点中的id

// 保证每次打开重新获取数据
watch(formDialogVisible, (val) => {
    if (!val) {
        selectId.value = ''
    }
})

// 分页相关
// page_size 改变触发
const handleSizeChange = (currentSize) => {
    search_data.value.page_size = currentSize
    getAppData()
}
// 页码改变触发
const handleCurrentChange = (currentPage) => {
    search_data.value.page = currentPage
    getAppData()
}
// 查看
const onShowClick = (row) => {
    selectId.value = row.id
    isForm.value = false
    formDialogVisible.value = true
}

// 编辑
const onEditClick = (row) => {
    selectId.value = row.id
    isForm.value = true
    formDialogVisible.value = true
}
// 添加
const onAddClick = () => {
    selectId.value = ''
    isForm.value = true
    formDialogVisible.value = true
}
// 删除

const onRemoveClick = (row) => {
    ElMessageBox.confirm('确定要删除 ' + row.name + ' 吗？', {
        type: 'warning'
    })
        .then(async () => {
            await delApp(row.id)
            ElMessage.success('删除成功！')
            // 重新渲染数据
            getAppData()
        })
        .catch(() => {})
}
// 排序
const handleSort = async () => {
    const soreObj = {}
    if (table_data.value.length === 0) return
    table_data.value.forEach((ele) => {
        soreObj[ele.id] = ele.list_order
    })
    await batchSort(soreObj)
    ElMessage.success('操作成功')
    getAppData()
}

// 被 keep-alive 缓存的组件激活时调用
onActivated(() => {
    getAppData()
})
</script>

<style lang="scss" scoped>
.header {
    margin-bottom: 20px;
}

.demo-date-picker {
    display: flex;
    width: 100%;
    padding: 0;
    flex-wrap: wrap;
}
.code {
    color: #337ab7;
    cursor: pointer;
}
.demo-date-picker .block {
    text-align: center;
    border-right: solid 1px var(--el-border-color);
    flex: 1;
}

.demo-date-picker .block:last-child {
    border-right: none;
}
.el-card {
    overflow-y: auto;
    overflow-x: auto;
}
.pagination {
    float: right;
}
</style>
